"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hearthHarmony = void 0;
const types_1 = require("../types");
const towne_1 = require("./towne");
exports.hearthHarmony = Object.assign(Object.assign({}, towne_1.towne), { meta: {
        title: "Hearth & Harmony Events",
        description: "Take part of Hearth & Harmony-sponsored events in your community!",
        image: (0, types_1.getFileUrl)("/hearth-harmony/tags/logo512.png"),
        icon: (0, types_1.getFileUrl)("/hearth-harmony/tags/favicon.ico"),
    }, company: {
        name: "Hearth & Harmony",
        logo: {
            url: (0, types_1.getFileUrl)("/hearth-harmony/logo.svg"),
            description: "hearth & harmony",
            style: {
                height: 25,
                width: "auto",
            },
            versions: {
                white: { url: (0, types_1.getFileUrl)("/hearth-harmony/logo-white.svg") },
            },
        },
    }, event: Object.assign(Object.assign({}, towne_1.towne.event), { type: {
            singular: "Experience",
            plural: "Experiences",
            singularWithArticle: "an Experience",
        } }), footerLinks: [
        {
            text: "Hearth & Harmony Privacy Policy",
            url: "https://www.max.live/privacy-policy",
        },
        { text: "MAX Privacy Policy", url: "https://www.max.live/privacy-policy" },
    ], fanAppUrl: `https://handh.live`, artistAppUrl: `https://dashboard.handh.live`, regionsCollection: "hearth_harmony_regions" });
